export const autoReplies = {
  hello:
    "Hello! Welcome to the TNPCB Chat Bot. How can I assist you with pollution and environmental concerns?",
  hi: "Hi! Welcome to the TNPCB Chat Bot. How can I assist you with pollution and environmental concerns?",
  good_morning:
    "Good morning! Welcome to the TNPCB Chat Bot. How can I help you today?",
  good_afternoon:
    "Good afternoon! Welcome to the TNPCB Chat Bot. How can I assist you with environmental queries?",
  good_evening:
    "Good evening! Welcome to the TNPCB Chat Bot. Let me know if you have any questions regarding pollution control.",
  good_night:
    "Good night! If you have any questions about TNPCB or our services, feel free to ask!",
  welcome: "Welcome to the TNPCB Chat Bot! How can I assist you today?",
  greetings:
    "Greetings! TNPCB is here to help you with environmental information and pollution control.",
  thank_you:
    "You're welcome! Feel free to ask if you have more questions about TNPCB and our services.",
  thanks:
    "You're welcome! I'm here to assist with any TNPCB or pollution control inquiries.",
  bye: "Goodbye! Thank you for visiting the TNPCB Chat Bot. Feel free to reach out if you have more questions.",
  goodbye:
    "Goodbye! Have a great day, and remember to stay informed about environmental care.",
  good_evening_tnpcb:
    "Good evening! How can TNPCB assist you today with environmental queries or pollution control info?",
  morning:
    "Good morning! I'm here to provide information on TNPCB's services and environmental monitoring.",
  afternoon:
    "Good afternoon! Welcome to TNPCB’s chat service. How may I assist you?",
  evening: "Good evening! How can I help you with your TNPCB queries?",
  night: "Good night! If you have any TNPCB questions, please let me know.",
  how_are_you:
    "I'm here and ready to help! How can I assist you with TNPCB-related inquiries?",
  fine: "Great to hear! Let me know if you have any questions about TNPCB or environmental issues.",
  help: "I'm here to help! You can ask me about TNPCB services, pollution monitoring, permits, and regulations.",
  support:
    "TNPCB support is here for your environmental queries! How can I assist?",
  services:
    "TNPCB offers a range of services including pollution monitoring, permit issuance, and environmental inspections.",
  pollution_info:
    "I can provide information on pollution control, air and water quality, and TNPCB regulations.",
  environment:
    "The TNPCB is committed to protecting the environment. Let me know how I can help you!",
  assistance:
    "I'm here to assist with all your TNPCB queries. Feel free to ask!",
  get_started:
    "Welcome! How can I help you get started with TNPCB-related information or services?",
  thanks_for_contacting:
    "Thank you for contacting TNPCB. How may we assist you today?",
  good_morning_environment:
    "Good morning! How can I assist you with environmental or TNPCB-related questions?",
  good_afternoon_tnpcb:
    "Good afternoon! TNPCB is here to help you with pollution and environmental concerns.",
  good_night_pollution:
    "Good night! Let me know if you need any information about pollution control and TNPCB regulations.",
  happy_to_help:
    "Happy to help! Please let me know your questions about TNPCB and environmental care.",
  what_can_you_do:
    "I can provide information on TNPCB regulations, pollution monitoring, permits, and environmental care.",
  tell_me_more:
    "Certainly! What would you like to know more about regarding TNPCB and our services?",
  inquiries:
    "I'm here to answer any inquiries you have about TNPCB services, pollution monitoring, and environmental standards.",
  help_with_pollution:
    "Need help with pollution control information? TNPCB is here to guide you.",
  assistance_needed:
    "I'm here to assist! Ask me anything related to TNPCB services, pollution monitoring, or environmental concerns.",
  tnpcb:
    "The Tamil Nadu Pollution Control Board (TNPCB) is responsible for monitoring and controlling pollution in Tamil Nadu.",
  pollution:
    "TNPCB monitors pollution levels across Tamil Nadu. You can get information on air and water quality indices by specific regions.",
  air: "Air quality monitoring is one of TNPCB's main activities. We track pollutant levels to provide real-time AQI data for major cities.",
  water:
    "TNPCB also monitors water quality in various rivers, lakes, and groundwater sources. Water quality reports are available for review.",
  permits:
    "TNPCB issues permits for industries to operate within environmental standards. You can apply for a CTE or CTO permit.",
  waste:
    "We regulate hazardous waste and biomedical waste management. TNPCB provides guidelines on proper waste disposal.",
  complaints:
    "If you have an environmental complaint, you can file it through TNPCB's Grievance Portal.",
  regulations:
    "TNPCB enforces regulations like the Environment Protection Act, Air Act, and Water Act to safeguard the environment.",
  contact:
    "You can reach TNPCB at their official helpline or visit the headquarters in Chennai for inquiries.",
  inspection:
    "TNPCB conducts routine inspections of industries to ensure compliance with environmental standards.",
  biomonitoring:
    "Biomonitoring of rivers and lakes helps TNPCB assess ecosystem health and detect pollution sources.",
  noise:
    "TNPCB monitors noise pollution levels in urban areas to ensure they remain within permissible limits.",
  emission:
    "Industries must monitor and control emissions. TNPCB enforces strict guidelines for air pollutant emissions.",
  epr: "Extended Producer Responsibility (EPR) mandates producers manage waste generated from their products.",
  solid_waste:
    "TNPCB oversees solid waste management practices, offering guidelines for disposal and treatment.",
  plastic:
    "TNPCB regulates the use of single-use plastics, aiming to reduce plastic pollution across Tamil Nadu.",
  hazardous:
    "Hazardous waste must be managed carefully. TNPCB provides guidelines for handling and disposal.",
  biomedical:
    "Biomedical waste, generated from healthcare facilities, must be disposed of per TNPCB’s guidelines.",
  recycling:
    "Recycling is encouraged, and TNPCB works to promote safe and effective recycling practices.",
  fines:
    "TNPCB can impose fines on industries violating pollution control standards.",
  climate_change:
    "We recognize the importance of addressing climate change and support initiatives to reduce emissions.",
  rivers:
    "TNPCB monitors pollution levels in major rivers, including the Kaveri, to ensure water quality.",
  groundwater:
    "TNPCB monitors groundwater quality in various regions and assesses pollution risks.",
  wetlands:
    "Wetlands are protected under TNPCB regulations to preserve biodiversity and prevent pollution.",
  deforestation:
    "TNPCB advocates for forest conservation to prevent soil erosion and maintain biodiversity.",
  ecotourism:
    "TNPCB promotes ecotourism and sustainable practices in natural reserves and parks.",
  penalties:
    "Violations of environmental laws may result in penalties, depending on the severity of the infraction.",
  licenses:
    "Industries require licenses from TNPCB to operate in compliance with environmental regulations.",
  consent:
    "Consent to Establish (CTE) and Consent to Operate (CTO) are permits required from TNPCB for industrial activities.",
  monitoring:
    "TNPCB conducts regular monitoring of air, water, and soil quality across Tamil Nadu.",
  vegetation:
    "Maintaining vegetation is vital for biodiversity and preventing land degradation.",
  biodiversity:
    "TNPCB supports efforts to protect the biodiversity of Tamil Nadu’s ecosystems.",
  awareness:
    "Public awareness is crucial. TNPCB conducts programs to educate people on pollution control.",
  education:
    "We promote environmental education initiatives to raise awareness about sustainability.",
  training:
    "TNPCB provides training on pollution control measures to various industries.",
  guidelines:
    "Our guidelines help industries comply with environmental standards.",
  report:
    "To report pollution, you can file a complaint with TNPCB’s online Grievance Portal.",
  air_quality:
    "The Air Quality Index (AQI) reflects pollution levels and is updated regularly.",
  water_quality:
    "Water quality assessments help us monitor river and lake pollution across Tamil Nadu.",
  health:
    "Poor air and water quality can impact health. TNPCB monitors pollutants to protect public health.",
  soil: "Soil quality monitoring is essential for agriculture and environmental health.",
  agriculture:
    "TNPCB monitors the use of pesticides and other chemicals to protect soil and water quality.",
  ozone:
    "The ozone layer protects us from UV radiation. TNPCB encourages practices that reduce ozone-depleting emissions.",
  sewage:
    "Sewage management is essential to prevent contamination of water bodies.",
  industries:
    "Industries in Tamil Nadu must follow TNPCB guidelines to minimize pollution.",
  green_energy:
    "TNPCB supports the use of renewable energy sources to reduce reliance on fossil fuels.",
  solar:
    "Solar energy is a sustainable option, and TNPCB promotes its adoption.",
  wind: "Wind energy is encouraged as part of TNPCB’s clean energy initiatives.",
  renewable:
    "Renewable energy helps reduce pollution and mitigate climate change.",
  vehicles:
    "TNPCB monitors vehicle emissions and encourages the use of cleaner fuels.",
  electric_vehicles:
    "Electric vehicles produce zero emissions and contribute to cleaner air.",
  fuel: "Switching to cleaner fuels helps reduce air pollution.",
  carbon:
    "Carbon emissions contribute to global warming. TNPCB encourages low-carbon practices.",
  pcr: "Pollution Control Research (PCR) studies are vital for developing pollution control strategies.",
  research: "Research on pollution prevention is supported by TNPCB.",
  technology:
    "Advanced technology can help reduce pollution and is encouraged by TNPCB.",
  data: "TNPCB collects environmental data to monitor pollution levels and assess trends.",
  weather:
    "Weather conditions impact pollution levels, and TNPCB monitors meteorological data.",
  rain: "Acid rain, caused by air pollution, can harm ecosystems and infrastructure.",
  erosion:
    "Soil erosion can be caused by deforestation. TNPCB promotes afforestation to combat erosion.",
  conservation: "Conservation of natural resources is a priority for TNPCB.",
  smog: "Smog is a mix of pollutants in the air and can impact health. TNPCB monitors air quality to address this.",
  trees: "Planting trees can reduce pollution and is encouraged by TNPCB.",
  environmental_impact:
    "Environmental Impact Assessments (EIA) are required for major projects to assess their effects.",
  eia: "EIA reports analyze the environmental impact of proposed projects before approval.",
  approvals:
    "TNPCB must approve major industrial projects to ensure they meet environmental standards.",
  projects:
    "Infrastructure projects must meet environmental guidelines set by TNPCB.",
  housing:
    "Housing developments are required to manage waste and emissions as per TNPCB guidelines.",
  tourism: "Tourism policies include measures to protect natural habitats.",
  cities: "Urban pollution is monitored to ensure healthy living conditions.",
  suburbs: "Suburban areas are also monitored for pollution levels.",
  fisheries: "Water quality in fisheries is regulated by TNPCB.",
  livestock:
    "Livestock farming practices should minimize waste and pollution as per TNPCB guidelines.",
  wildlife: "Wildlife conservation efforts help maintain ecosystem balance.",
  fishery:
    "Water pollution impacts fisheries, and TNPCB monitors water quality in fishing areas.",
  plastic_ban: "The ban on single-use plastics helps reduce plastic pollution.",
  recycling_plastics: "Recycling plastics reduces waste and pollution.",
  urban_planning:
    "Sustainable urban planning is essential for controlling pollution.",
  construction:
    "Construction sites must follow TNPCB regulations to control dust and emissions.",
  climate:
    "Climate action is vital to protect the environment and human health.",
  energy: "Energy efficiency reduces pollution and supports sustainability.",
  thermal:
    "Thermal power plants must manage emissions in line with TNPCB standards.",
  agriculture_waste:
    "Proper disposal of agricultural waste is necessary to prevent pollution.",
  aquaculture:
    "Water quality in aquaculture is regulated to protect the environment.",
  mining: "Mining activities must adhere to TNPCB's environmental guidelines.",
};
